import { createFileRoute } from '@tanstack/react-router'
import { AuditLogViewer } from '@/components/workforce/AuditLogViewer'

export const Route = createFileRoute('/_auth/workforce/audit-logs')({
  component: AuditLogViewerPage,
})

function AuditLogViewerPage() {
  return <AuditLogViewer />
}
